/* istanbul ignore file */

const config = {
  applicationInsightsKey: process.env.REACT_APP_APPLICATION_INSIGHTS_KEY || '',
  clientId: process.env.REACT_APP_CLIENT_ID || '',
  defaultResourceTimeout: process.env.DEFAULT_RESOURCE_TIMEOUT_IN_MILLI_SECOND || '120000',
  OPServer: process.env.REACT_APP_OP_SERVER || '',
  postLogoutRedirectUri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI || '',
  filePortalLogo: process.env.REACT_APP_FILE_PORTAL_ICON || '',
  resourceServer: process.env.REACT_APP_RESOURCE_SERVER || '',
  resourceServerByDdms: process.env.REACT_APP_RESOURCE_SERVER_BY_DDMS || '',
  redirectURL: process.env.REACT_APP_REDIRECT_URL || '',
  oauth2Scope: process.env.REACT_APP_SCOPE || 'openid',
  ddmsURL: process.env.REACT_APP_DDMS_URL || '',
  photoURL: process.env.REACT_APP_PHOTO_URL || '',
  spiderPlusURL: process.env.REACT_APP_SPIDER_PLUS_URL || '',
  exchangeManagerURL: process.env.REACT_APP_EXCHANGE_MANAGER_URL || '',
  photoParameterKeyProjectId: process.env.REACT_APP_PHOTO_PARAMETER_KEY_PROJECT_ID ?? 'xgrab_project_id',
  projectInvitationURL: process.env.REACT_APP_PROJECT_INVITATION_URL || '',
  projectInvitationParameterKeyProjectId: process.env.REACT_APP_PROJECT_INVITATION_PARAMETER_KEY_PROJECT_ID ?? 'project_id',
  groupManagerURL: process.env.REACT_APP_GROUP_MANAGER_URL || '',
  groupManagerParameterKeyProjectId: process.env.REACT_APP_GROUP_MANAGER_PARAMETER_KEY_PROJECT_ID ?? 'project_id',
  serviceParameterKeyProjectId: process.env.REACT_APP_SERVICE_PARAMETER_KEY_PROJECT_ID ?? 'project_id',
  gadgetSettings: {
    mainMenu: {
      display_name_ja: process.env.REACT_APP_GADGET_SETTING_MAINMENU_DISPLAYNAME_JA,
      display_name_en: process.env.REACT_APP_GADGET_SETTING_MAINMENU_DISPLAYNAME_EN,
      width: process.env.REACT_APP_GADGET_SETTING_MAINMENU_WIDTH,
      height: process.env.REACT_APP_GADGET_SETTING_MAINMENU_HEIGHT,
    },
    downloadHistory: {
      display_name_ja: process.env.REACT_APP_GADGET_SETTING_DOWNLOADHISTORY_DISPLAYNAME_JA,
      display_name_en: process.env.REACT_APP_GADGET_SETTING_DOWNLOADHISTORY_DISPLAYNAME_EN,
      width: process.env.REACT_APP_GADGET_SETTING_DOWNLOADHISTORY_WIDTH,
      height: process.env.REACT_APP_GADGET_SETTING_DOWNLOADHISTORY_HEIGHT,
    },
    myShortcut: {
      display_name_ja: process.env.REACT_APP_GADGET_SETTING_MYSHORTCUT_DISPLAYNAME_JA,
      display_name_en: process.env.REACT_APP_GADGET_SETTING_MYSHORTCUT_DISPLAYNAME_EN,
      width: process.env.REACT_APP_GADGET_SETTING_MYSHORTCUT_WIDTH,
      height: process.env.REACT_APP_GADGET_SETTING_MYSHORTCUT_HEIGHT,
    },
    newArrival: {
      display_name_ja: process.env.REACT_APP_GADGET_SETTING_NEWARRIVAL_DISPLAYNAME_JA,
      display_name_en: process.env.REACT_APP_GADGET_SETTING_NEWARRIVAL_DISPLAYNAME_EN,
      width: process.env.REACT_APP_GADGET_SETTING_NEWARRIVAL_WIDTH,
      height: process.env.REACT_APP_GADGET_SETTING_NEWARRIVAL_HEIGHT,
    },
    searchCriteria: {
      display_name_ja: process.env.REACT_APP_GADGET_SETTING_SEARCHCRITERIA_DISPLAYNAME_JA,
      display_name_en: process.env.REACT_APP_GADGET_SETTING_SEARCHCRITERIA_DISPLAYNAME_EN,
      width: process.env.REACT_APP_GADGET_SETTING_SEARCHCRITERIA_WIDTH,
      height: process.env.REACT_APP_GADGET_SETTING_SEARCHCRITERIA_HEIGHT,
    },
  },
  gridSettings: {
    downloadHistory: {
      columns: process.env.REACT_APP_DISPLAY_COLUMNS_DOWNLOADHISTORY,
    },
    newArrival: {
      columns: process.env.REACT_APP_DISPLAY_COLUMNS_NEWARRIVAL,
    },
    searchCriteria: {
      columns: process.env.REACT_APP_DISPLAY_COLUMNS_SEARCHCRITERIA,
    },
  },
};

export default config;
